import { persistState } from '@datorama/akita';

export const akitaStorage = persistState();
